<template>
  <v-card flat class="v2-card">
    <v-card-text>
      <v-layout row wrap align-center class="v2-filters">
        <v-flex xs12 sm6 md3 lg2>
          <v-select :items="sortItems" v-model="tableData.column" @change="getData" label="Sort By" item-text="name" item-value="value" return-object single-line outline dense hide-details></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3 lg2>
          <v-select :items="statuses" v-model="tableData.filter.syndication_status" @change="getData" label="Status" item-text="syndication_status" item-value="syndication_status" single-line outline dense hide-details></v-select>
        </v-flex>
        <v-flex xs6 sm3 md2 lg1>
          <v-select :items="agreement_dates" v-model="tableData.filter.syndication_agreement_date" @change="getData" label="M/Y" item-text="syndication_agreement_date" item-value="syndication_agreement_date" single-line outline dense hide-details></v-select>
        </v-flex>
        <v-flex xs6 sm3 md1 lg1>
          <v-select :items="[25, 50, 100, 200]" v-model="tableData.length" @change="getData" label="Rows" single-line outline dense hide-details></v-select>
        </v-flex>
        <v-flex xs12 sm6 md3 lg2>
          <v-text-field v-model="tableData.search" @input="getData" label="Search" prepend-inner-icon="search" outline hide-details></v-text-field>
        </v-flex>
        <v-flex xs6 sm3 md2 lg1>
          <v-menu v-model="menu1" :close-on-content-click="false" full-width max-width="290">
            <v-text-field slot="activator" v-model="tableData.excel_origin_start_date" label="Payout start" readonly outline hide-details></v-text-field>
            <v-date-picker v-model="tableData.excel_origin_start_date" @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 sm3 md2 lg1>
          <v-menu v-model="menu2" :close-on-content-click="false" full-width max-width="290">
            <v-text-field slot="activator" v-model="tableData.excel_origin_end_date" label="Payout end" readonly outline hide-details></v-text-field>
            <v-date-picker v-model="tableData.excel_origin_end_date" @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm6 md2 lg2 class="text-xs-right v2-filter-actions">
          <v-tooltip top>
            <v-btn slot="activator" icon class="ma-0" @click="reset"><v-icon small>event_busy</v-icon></v-btn>
            <span>Clear payout dates</span>
          </v-tooltip>
          <v-btn color="primary" depressed class="ma-0 ml-1" :loading="excelBtnLoader" @click="exportReport">
            <v-icon left small>file_download</v-icon>Export
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-progress-linear :indeterminate="processBar" height="3" class="my-0"></v-progress-linear>
    <div class="v2-table-scroll">
      <v-data-table :headers="headers" :items="dealSyndication_payouts" item-key="id" :expand="false" hide-actions disable-initial-sort :pagination.sync="pagination" @update:pagination="onPagination">
        <template slot="items" slot-scope="props">
          <tr class="v2-row" @click="toggleRow(props)">
            <td class="hidden-xs-only">{{ props.item.syndication_agreement_date }}</td>
            <td><v-chip small outline :color="statusColor(props.item.syndication_status)">{{ props.item.syndication_status }}</v-chip></td>
            <td class="hidden-xs-only">{{ props.item.syndication_platform }}</td>
            <td>{{ props.item.syndication_company_name }}</td>
            <td class="hidden-xs-only">{{ props.item.contract_MID }}</td>
            <td class="hidden-xs-only">{{ props.item.syndication_participation_percent }}%</td>
            <td class="hidden-xs-only">{{ props.item.syndication_participation_amt | currency }}</td>
            <td class="hidden-xs-only">{{ props.item.syndication_commission_amt | currency }}</td>
            <td class="hidden-xs-only">{{ props.item.syndication_total_participation_amt | currency }}</td>
            <td class="hidden-xs-only">
              {{ props.item.syndication_management_fee_percent }}%
              <v-chip v-if="props.item.syndication_management_fee_upfront == 1 || props.item.syndication_management_fee_upfront == 2" small label>Upfront</v-chip>
            </td>
            <td class="hidden-xs-only">{{ props.item.syndication_part_rtr | currency }}</td>
            <td>
              <template v-if="isExcludedBalance(props.item.syndication_status)">$0.00</template>
              <template v-else>{{ props.item.syndication_balance | currency }}</template>
            </td>
            <td class="hidden-xs-only">{{ getPercentage(props.item.paid_percentage) }}%</td>
            <td>{{ props.item.net_profit | currency }} ({{ getPercentagePaid(props.item.net_profit || 0, props.item.syndication_total_participation_amt) }}%)</td>
            <td class="hidden-xs-only">{{ props.item.performance ? props.item.performance : '' }}</td>
            <td v-if="showFcs">
              <v-btn icon small class="ma-0" @click.stop="redirectFcs(props.item.deal_unique_id)"><v-icon small>input</v-icon></v-btn>
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <DealExpand :payouts="deal_payouts" :contract_MID="props.item.contract_MID" />
        </template>
      </v-data-table>
    </div>
    <div class="text-xs-center py-2">
      <v-pagination v-model="tableData.page" :length="pages" :total-visible="$vuetify.breakpoint.xsOnly ? 3 : 7" @input="next"></v-pagination>
    </div>
  </v-card>
</template>

<script>
import user_helper from '../../../helpers/user_helper'
import dealsTable from '../../mixins/dealsTable'
import DealExpand from './DealExpand.vue'

const HEADERS = [
  { text: 'Agreement Date', value: 'syndication_agreement_date', class: 'hidden-xs-only' },
  { text: 'Status', value: 'syndication_status' },
  { text: 'Platform', value: 'syndication_platform', class: 'hidden-xs-only' },
  { text: 'Merchant', value: 'syndication_company_name' },
  { text: 'MID', value: 'contract_MID', class: 'hidden-xs-only' },
  { text: '% syndicated', value: 'syndication_participation_percent', class: 'hidden-xs-only' },
  { text: 'Syndication Amount', value: 'syndication_participation_amt', class: 'hidden-xs-only' },
  { text: 'Commission Paid', value: 'syndication_commission_amt', class: 'hidden-xs-only' },
  { text: 'Total Investment Cost', value: 'syndication_total_participation_amt', class: 'hidden-xs-only' },
  { text: 'Mgt. Fees', value: 'syndication_management_fee_percent', class: 'hidden-xs-only' },
  { text: 'Part RTR', value: 'syndication_part_rtr', class: 'hidden-xs-only' },
  { text: 'Balance', value: 'syndication_balance' },
  { text: 'Paid in %', value: 'paid_percentage', class: 'hidden-xs-only' },
  { text: 'Net profit', value: 'net_profit' },
  { text: 'Performance', value: 'performance', class: 'hidden-xs-only' },
]

export default {
  mixins: [user_helper, dealsTable],
  components: { DealExpand },
  data: () => ({
    exportType: '',
    sortValueFallback: 'deal_payouts_tbl.total_net_pay',
    menu1: false,
    menu2: false,
    sortItems: [
      { name: 'Latest agreement date', value: { column: 'deal_syndications.syndication_agreement_date', sortBy: 'DESC' } },
      { name: 'Oldest agreement date', value: { column: 'deal_syndications.syndication_agreement_date', sortBy: 'ASC' } },
      { name: 'Highest net pay', value: { column: 'deal_payouts_tbl.total_net_pay', sortBy: 'DESC' } },
      { name: 'Lowest net pay', value: { column: 'deal_payouts_tbl.total_net_pay', sortBy: 'ASC' } },
      { name: 'Highest Balance', value: { column: 'deal_syndications.syndication_balance', sortBy: 'DESC' } },
      { name: 'Lowest Balance', value: { column: 'deal_syndications.syndication_balance', sortBy: 'ASC' } },
    ],
  }),
  computed: {
    showFcs() {
      return this.userpermission.syndawiz_fcs == 'On'
    },
    headers() {
      return this.showFcs ? [...HEADERS, { text: 'View FCS', sortable: false }] : HEADERS
    },
  },
  methods: {
    reset() {
      this.tableData.excel_origin_start_date = null
      this.tableData.excel_origin_end_date = null
      this.getData()
    },
    exportFileName() {
      return 'syndicated_deals(' + this.tableData.excel_origin_start_date + ' - ' + this.tableData.excel_origin_end_date + ').xlsx'
    },
  },
}
</script>
